export default __webpack_public_path__ + "static/char-v-57-67180f18d719615ce1ae2b8fc4cd5805.webp";